import { colors } from 'shared/style/colors'

export const baseScrollBar = {
  '&::-webkit-scrollbar': {
    w: '17px',
    bg: 'transparent',
  },
  '&::-webkit-scrollbar-track': {
    mt: '8px',
    mb: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '6px',
    borderRightRadius: '9px',
    bg: colors['primary-gray-40'],
    borderLeft: `3px solid transparent`,
    borderRight: `7px solid transparent`,
    backgroundClip: 'content-box',
  },
}
